import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {DropDownAnimation} from "../../common/animations";

@Component({
  selector: 'app-simple-accordion',
  templateUrl: './simple-accordion.component.html',
  styleUrls: ['./simple-accordion.component.scss'],
  animations: [DropDownAnimation],
  encapsulation: ViewEncapsulation.ShadowDom
})
export class SimpleAccordionComponent implements OnInit {
  @Input() isOpen: boolean = false
  @Input() title: any;
  @Input() description: any;
  @Input() boldTitle: boolean;
  @Input() arrowRight: boolean;
  constructor() { }

  ngOnInit(): void {
  }

}
